/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerRemoveMutationResponse, ApplicationsControllerRemovePathParams, ApplicationsControllerRemove401, ApplicationsControllerRemove403, ApplicationsControllerRemove404 } from "../../models/checklistsController/ApplicationsControllerRemove";

function getApplicationsControllerRemoveUrl(id: ApplicationsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-applications/${id}` as const }  
  return res
}

/**
 * @description Requires the create permission on the template kind (Apply/remove reviews or Apply/remove Playbooks).
 * @summary Delete a checklist application (soft delete)
 * {@link /api/v1/checklist-applications/:id}
 */
export async function applicationsControllerRemove(id: ApplicationsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerRemoveMutationResponse, ResponseErrorConfig<ApplicationsControllerRemove401 | ApplicationsControllerRemove403 | ApplicationsControllerRemove404>, unknown>({ method : "DELETE", url : getApplicationsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}